@if (items.length === 0) {
  <span class="text-subdued px-8 py-2 text-sm">
    No Folders found
  </span>
}
<div appSelectableList #appSelectableList="appSelectableList" [deselectOnReclick]="false">
  <app-sidebar-item
    class="rounded [&:not(.drag-over)]:hover:bg-hover"
    *nestedFor="
      let folder of items;
      let index = index;
      let depth = depth;
      let expandable = expandable;
      let itemExpanded = expanded;
      stateKey: treeStateKey;
    "
    [title]="folder.title"
    [depth]="depth"
    [badge]="{ template: badgeTemplate, context: { flagged: folder.flagged, pinned: folder.pinned, snoozed: folder.snoozed, followed: folder.followed } }"
    iconSlot="none"
    [expandable]="expandable"
    [expanded]="itemExpanded.value"
    [active]="selectedItemsIds | includesBy : folder?.id"
    (onExpand)="itemExpanded.next($event)"
    (appClick)="openItem(folder)"
    (appDblClick)="handleDblClick(folder)"
    [appMessageFolderContextMenu]="folder"
    [appMessageFolderContextMenuMailboxTenantId]="mailboxTenantId"
    [appSelectable]="folder.id"
    [appSelectablePosition]="index"
    [appSelectableIdentifier]="folder.id"
    [appSelectableListRef]="appSelectableList"

    [class.drop-disabled]="isDragging && dropBlocked"
    [class.opacity-40]="isDragging && dropBlocked"
    appDroppable
    appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="dndPredicate(folder)"
    (appDroppableDrop)="dndDrop($event, folder)"
    (appDroppableEnter)="onItemDragEnter($event, folder.id)"
    (appDroppableLeave)="onItemDragLeave(folder.id)"

    appDraggable
    [appDraggableData]="items | selectedItemsDragData: selectedItemsIds: folder"
    [appDraggablePlaceholder]="placeholder"
    [appDraggablePlaceholderContext]="{ item: folder }"
    >
    @if (messagesCount?.[folder.id]) {
      &ngsp;<span
        data-testid="folder-unread-count"
        [class.text-strong]="selectedItemsIds | includesBy: folder.id"
      >{{ messagesCount[folder.id] }}</span>
    }
  </app-sidebar-item>
</div>

<ng-template #badgeTemplate let-flagged=flagged let-pinned=pinned let-snoozed=snoozed let-followed=followed>
  <div class="badge-template h-full flex flex-col justify-center items-center">
    @if (pinned) {
      <app-icon
        class="text-primary"
        size="xs"
        name="sapphire-pin-filled"
      />
    }
    @if (flagged) {
      <app-icon
        class="text-orange-500"
        name="sapphire-flagged-filled"
        size="xs"
      />
    }
    @if (snoozed) {
      <app-icon
        class="text-orange-500"
        name="sapphire-snooze"
        size="xs"
      />
    }
    @if (followed) {
      <app-icon
        class="text-primary"
        name="sapphire-follow-up"
        size="xs"
      />
    }
  </div>
</ng-template>
